import React, { PureComponent } from 'react';
import CommonList from '../../components/CommonLists/list';
import moment from 'moment';
import './index.less';
const columns = [
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title',
    render: (text, record) => {
      return (
        <p>
          {record.is_top === 1 && <span className="top">[置顶]</span>}
          {text}
        </p>
      );
    }
  },
  {
    title: '别名',
    dataIndex: 'cname',
    key: 'cname',
    width: '20%'
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
    key: 'update_time',
    width: '12%',
    render: text => {
      return <p>{moment(text).format('YYYY-MM-DD h:mm:ss')}</p>;
    }
  }
];

@CommonList(columns, 'news')
class SinglePagesList extends PureComponent {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return <div />;
  }
}

export default SinglePagesList;
